const connections = {
  getJiraConnectionInfo() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/tools/jira', defaults);
  },
  setJiraConnectionInfo(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/tools/jira', Object.assign(defaults, { data }));
  },
  getJiraProjectList(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };
    return this.request('/1/tools/jira/projects', Object.assign(defaults, { data }));
  },
  getJiraAssignee(data) {
    //{"project_key": "ICA"}
    const defaults = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };
    return this.request('/1/tools/jira/project_user', Object.assign(defaults, { data }));
  },
  setJiraAssignee(data) {
    //{"issue_key": "ICA-1757", "account_id": "5b1ddc58edacc156e2f35925"}
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/tools/jira/issue_assign', Object.assign(defaults, { data }));
  },
  getJiraComponents(data) {
    //{"project_id": "10006"}
    const defaults = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };
    return this.request('/1/tools/jira/project_component', Object.assign(defaults, { data }));
  },
  getJiraIssueType(data) {
    //{"project_id": "10006"}
    const defaults = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };
    return this.request('/1/tools/jira/project_issue_type', Object.assign(defaults, { data }));
  },
  getJiraPriority() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/tools/jira/priorities', defaults);
  },
  getJiraLabel() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/tools/jira/labels', defaults);
  },
  getJiraIssueWithPolicy(policyId) {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/tools/${policyId}/policy`, defaults);
  },
  setJiraIssueWithPolicy(policyId, data) {
    //{"issue_key": "ICA-1757", "account_id": "5b1ddc58edacc156e2f35925"}
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/tools/${policyId}/policy`, Object.assign(defaults, { data }));
  },
  deleteJiraIssueWithPolicy(policyId) {
    const defaults = {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/tools/${policyId}/policy`, Object.assign(defaults));
  },
  getJiraIssueWitUser() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/tools/user_jira', defaults);
  },
  setJiraIssueWithUser(uid, data) {
    const defaults = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };
    return this.request(`/1/tools/${uid}/policy_create`, Object.assign(defaults, { data }));
  },
  setJiraIssueWithClarityIssue(uid, data) {
    const defaults = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };
    return this.request(`/1/tools/${uid}/issue_create`, Object.assign(defaults, { data }));
  },
  setJiraIssueWithReport(uid, data) {
    const defaults = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };
    return this.request(`/1/tools/${uid}/report_create`, Object.assign(defaults, { data }));
  },
  getJiraIssueWitSettings() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/tools/issue', defaults);
  },
  deleteJiraIssueWithSettings() {
    const defaults = {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/tools/issue', Object.assign(defaults));
  },
  setJiraIssueWitSettings(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/tools/issue', Object.assign(defaults, { data }));
  },
  getJiraIssueSettingsWithContinuousScan() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/tools/continuous_scan', defaults);
  },
  deleteJiraIssueSettingsWithContinuousScan() {
    const defaults = {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/tools/continuous_scan', Object.assign(defaults));
  },
  setJiraIssueSettingsWithContinuousScan(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/tools/continuous_scan', Object.assign(defaults, { data }));
  },
};
export default connections;
